// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"af1f6d21","316":"786f94bf"}[chunkId] + ".chunk.js";
};